import { useEffect, useState } from 'react'

import checkoutSdk from './checkoutSdk'

const useCheckoutFrame = (frameRef, services) => {
  const [boundCheckoutFrame, setBoundCheckoutFrame] = useState(null)
  useEffect(() => {
    const waitForFrame = async () => {
      const frame = frameRef.current
      if (!frame) {
        return
      }
      const origin = frame.src.split('/').slice(0, 3).join('/')
      const activatedFrame = await checkoutSdk({ frame, origin, services })
      setBoundCheckoutFrame(activatedFrame)
    }
    waitForFrame()
    return () => {
      if (boundCheckoutFrame) {
        boundCheckoutFrame.unbind()
      }
    }
  }, [setBoundCheckoutFrame, frameRef])
  return boundCheckoutFrame
}

export default useCheckoutFrame
